// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Client Detail Modal Styles */
.client-detail-modal .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.client-detail-modal .ant-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eaedf3;
  background-color: #f8f9fa;
}

.client-detail-modal .ant-modal-body {
  padding: 0;
}

.client-detail-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.client-detail-modal .ant-modal-close-x {
  width: 32px;
  height: 32px;
  line-height: 32px;
}

/* Modal Title */
.client-modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.client-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.client-name-modal {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.client-id-modal {
  font-size: 14px;
  color: #666666;
  background-color: #f0f7ff;
  padding: 4px 12px;
  border-radius: 16px;
}

.client-pod {
  font-size: 14px;
  color: #666666;
  background-color: #f0f7ff;
  padding: 4px 12px;
  border-radius: 16px;
}

/* Modal Content */
.client-modal-content {
  padding: 24px;
}

/* Summary Cards */
.client-summary-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 16px;
  gap: 16px;
  margin-bottom: 24px;
}

.summary-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  border: 1px solid #eaedf3;
}

.summary-card-value {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.summary-card-label {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.info-icon {
  color: #3B82F6;
  font-size: 14px;
  cursor: help;
}

/* Calendar Styles */
.client-calendar-container {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaedf3;
}

.client-calendar .ant-picker-calendar-header {
  padding: 12px 16px;
}

.client-calendar .ant-picker-cell {
  padding: 4px;
}

.client-calendar .ant-picker-calendar-date {
  height: 100px;
  margin: 0;
  padding: 4px;
  border-radius: 8px;
}

.client-calendar .ant-picker-calendar-date-today {
  border-color: #3B82F6;
}

.client-calendar .ant-picker-calendar-date-value {
  font-weight: 600;
}

/* Day Data Styles */
.client-day-data {
  padding: 8px;
  border-radius: 6px;
  margin-top: 4px;
  height: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.client-day-amount {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

.client-day-count {
  font-size: 12px;
  color: #666666;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  gap: 16px;
}

.loading-container p {
  color: #666666;
  margin-top: 12px;
}

/* Empty State */
.empty-data {
  padding: 60px 0;
}

/* Export Button */
.export-button {
  border-radius: 8px;
  background-color: #f0f7ff;
  color: #3B82F6;
  border-color: #d0e1fd;
}

.export-button:hover {
  background-color: #e0efff;
  color: #2563eb;
  border-color: #b0d0fc;
}

/* Responsive Adjustments */
@media (max-width: 992px) {
  .client-summary-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .client-modal-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .client-info {
    margin-bottom: 12px;
  }
  
  .client-summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .client-calendar .ant-picker-calendar-date {
    height: 80px;
  }
}

@media (max-width: 576px) {
  .client-summary-cards {
    grid-template-columns: 1fr;
  }
  
  .client-day-amount {
    font-size: 12px;
  }
  
  .client-day-count {
    font-size: 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Contribution/Incentive/ClientDetailModal.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Client Detail Modal Styles */\n.client-detail-modal .ant-modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.client-detail-modal .ant-modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #eaedf3;\n  background-color: #f8f9fa;\n}\n\n.client-detail-modal .ant-modal-body {\n  padding: 0;\n}\n\n.client-detail-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.client-detail-modal .ant-modal-close-x {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n\n/* Modal Title */\n.client-modal-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.client-info {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.client-name-modal {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333333;\n}\n\n.client-id-modal {\n  font-size: 14px;\n  color: #666666;\n  background-color: #f0f7ff;\n  padding: 4px 12px;\n  border-radius: 16px;\n}\n\n.client-pod {\n  font-size: 14px;\n  color: #666666;\n  background-color: #f0f7ff;\n  padding: 4px 12px;\n  border-radius: 16px;\n}\n\n/* Modal Content */\n.client-modal-content {\n  padding: 24px;\n}\n\n/* Summary Cards */\n.client-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.summary-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  text-align: center;\n  border: 1px solid #eaedf3;\n}\n\n.summary-card-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 8px;\n}\n\n.summary-card-label {\n  font-size: 14px;\n  color: #666666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.info-icon {\n  color: #3B82F6;\n  font-size: 14px;\n  cursor: help;\n}\n\n/* Calendar Styles */\n.client-calendar-container {\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eaedf3;\n}\n\n.client-calendar .ant-picker-calendar-header {\n  padding: 12px 16px;\n}\n\n.client-calendar .ant-picker-cell {\n  padding: 4px;\n}\n\n.client-calendar .ant-picker-calendar-date {\n  height: 100px;\n  margin: 0;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.client-calendar .ant-picker-calendar-date-today {\n  border-color: #3B82F6;\n}\n\n.client-calendar .ant-picker-calendar-date-value {\n  font-weight: 600;\n}\n\n/* Day Data Styles */\n.client-day-data {\n  padding: 8px;\n  border-radius: 6px;\n  margin-top: 4px;\n  height: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.client-day-amount {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333333;\n}\n\n.client-day-count {\n  font-size: 12px;\n  color: #666666;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n  gap: 16px;\n}\n\n.loading-container p {\n  color: #666666;\n  margin-top: 12px;\n}\n\n/* Empty State */\n.empty-data {\n  padding: 60px 0;\n}\n\n/* Export Button */\n.export-button {\n  border-radius: 8px;\n  background-color: #f0f7ff;\n  color: #3B82F6;\n  border-color: #d0e1fd;\n}\n\n.export-button:hover {\n  background-color: #e0efff;\n  color: #2563eb;\n  border-color: #b0d0fc;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 992px) {\n  .client-summary-cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .client-modal-title {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .client-info {\n    margin-bottom: 12px;\n  }\n  \n  .client-summary-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .client-calendar .ant-picker-calendar-date {\n    height: 80px;\n  }\n}\n\n@media (max-width: 576px) {\n  .client-summary-cards {\n    grid-template-columns: 1fr;\n  }\n  \n  .client-day-amount {\n    font-size: 12px;\n  }\n  \n  .client-day-count {\n    font-size: 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
